var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      attrs: {
        flat: "",
        small: "",
        "data-permiso": "Exportar",
        color: "primary"
      },
      on: {
        click: function($event) {
          return _vm.handleClick()
        }
      }
    },
    [
      _c("v-icon", { staticClass: "icon" }, [_vm._v("cloud_download")]),
      _vm._v("  \n  "),
      _c("span", { staticClass: "text" }, [_vm._v("Exportar")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }